// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"557":"3f52d253","635":"f86575f6","685":"d662159c","736":"b3ab94fd"}[chunkId] + ".chunk.css";
};